module.exports = __webpack_public_path__ + "static/media/woman_ipad_couch.2a1e49e3.png";